// src/components/HRComponents/PolicyVersionTimeline.js
import React from 'react';
import { CheckCircle2, Clock, FileEdit } from 'lucide-react';
import { formatDateTime } from '../../helpers/formatDateTime';

const STATUS_ICON = {
  published: <CheckCircle2 className="h-4 w-4 text-green-600" />,
  superseded: <Clock className="h-4 w-4 text-gray-400" />,
  draft: <FileEdit className="h-4 w-4 text-yellow-500" />,
  pending_approval: <Clock className="h-4 w-4 text-yellow-500" />,
  approved: <CheckCircle2 className="h-4 w-4 text-blue-500" />, // FIX: Added a distinct blue icon for approved versions
};

const PolicyVersionTimeline = ({ versions = [] }) => {
  if (!versions.length) {
    return <p className="text-sm text-gray-400">No versions yet.</p>;
  }

  return (
    <div className="space-y-3">
      {versions.map((v) => (
        <div key={v._id} className="flex items-start gap-3 bg-white border rounded-lg p-3">
          <div className="mt-0.5">{STATUS_ICON[v.status] || <FileEdit className="h-4 w-4 text-gray-400" />}</div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-gray-900">Version {v.versionNumber}</span>
              <span className="text-xs text-gray-400 capitalize">{v.status.replace('_', ' ')}</span>
            </div>
            {v.changeSummary && <p className="text-xs text-gray-500 mt-0.5">{v.changeSummary}</p>}
            <p className="text-xs text-gray-400 mt-1">
              {v.fileName || 'In-app authored content'} · by {v.createdBy?.firstName || 'Unknown'} · {formatDateTime(v.createdAt, true)}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PolicyVersionTimeline;